<script lang="ts">
  import emblaCarouselSvelte from 'embla-carousel-svelte';
  import type { EmblaCarouselType } from 'embla-carousel';

  import SliderButton from '$components/ui/slider-button.svelte';
  import Slider from '$components/slider.svelte';

  import { t } from '$lib/i18n';
  import { cn } from '$lib/utils';
  import { reducedMotion } from '$lib/stores/reduced-motion';
  import { createEventDispatcher } from 'svelte';

  export let total: number;
  export let active = total > 1;
  export let href: string | undefined = undefined;
  let className: string | undefined = undefined;
  export { className as class };

  let currentIndex = 0;
  let emblaApi: EmblaCarouselType;

  $: if (currentIndex > 0 && !active) currentIndex = 0;

  export const next = () => emblaApi && emblaApi.scrollNext($reducedMotion);
  export const prev = () => emblaApi && emblaApi.scrollPrev($reducedMotion);

  const dispatch = createEventDispatcher<{ triggerElevar: undefined; handleClick: undefined }>();

  const triggerElevar = () => {
    dispatch('triggerElevar');
  };

  const handleClick = () => {
    dispatch('handleClick');
  };
</script>

<div class={cn('relative isolate bg-background rounded-md overflow-hidden group', className)}>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <svelte:element
    this={href ? 'a' : 'div'}
    data-sveltekit-noscroll={false}
    {href}
    on:click={href ? triggerElevar : handleClick}
    tabindex={-1}
    class="block overflow-hidden w-full h-full bg-highlight/64"
    use:emblaCarouselSvelte={{
      options: { loop: true, duration: 20, active },
      plugins: []
    }}
    on:emblaInit={({ detail: api }) => {
      emblaApi = api;
      api.on('select', (e) => (currentIndex = e.selectedScrollSnap()));
    }}
  >
    <div class="gallery-container w-full h-full flex relative">
      <slot itemClass="block object-cover min-w-full min-h-full flex-[0_0_100%]" />
    </div>
  </svelte:element>

  {#if total > 1}
    <SliderButton
      aria-label={$t('a11y.image-previous')}
      icon="chevron-left"
      class="absolute z-10 left-[var(--product-card-inset,theme(spacing.2))] top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 focus-visible:opacity-100"
      on:click={() => prev()}
    />
    <SliderButton
      aria-label={$t('a11y.image-next')}
      icon="chevron-right"
      class="absolute z-10 right-[var(--product-card-inset,theme(spacing.2))] top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 focus-visible:opacity-100"
      on:click={() => next()}
    />
    <Slider
      {total}
      {currentIndex}
      class="absolute bottom-[var(--product-card-inset,theme(spacing.2))] left-[var(--product-card-inset,theme(spacing.2))] pointer-events-none"
    />
  {/if}
</div>

<style>
  .gallery-container {
    backface-visibility: hidden;
    touch-action: pan-y;
  }
</style>
